// Bridges page - Tremolo hotspot configuration
// Uses HotspotManager from /js/pages/hotspot-manager.js

const tremoloParts = [
    {
        name: "Tremolo - Fixed Bridge<br>Toggle",
        description: "Precision-machined titanium base provides remarkable stability and sustain while maintaining lightweight design.",
        x: 50, y: 69,
        labelOffsetX: 12, labelOffsetY: 0,
        tabletX: 50, tabletY: 70,
        tabletLabelOffsetX: 5, tabletLabelOffsetY: -18,
        mobileX: 51, mobileY: 71,
        mobileLabelOffsetX: -4.5, mobileLabelOffsetY: -9.3,
        usePercentage: true
    },
    {
        name: "Full Range<br>Precision Tuners",
        description: "Secure locking mechanism ensures perfect tuning stability even with aggressive tremolo use.",
        x: 27, y: 95,
        labelOffsetX: -24, labelOffsetY: -9,
        tabletX: 28, tabletY: 96,
        tabletLabelOffsetX: -33, tabletLabelOffsetY: -7,
        mobileX: 29, mobileY: 97,
        mobileLabelOffsetX: -16.5, mobileLabelOffsetY: .5,
        usePercentage: true
    },
    {
        name: "Isolated String<br>Tension system",
        description: "Fine-tuning system allows for precise adjustments without unlocking strings.",
        x: 42, y: 85,
        labelOffsetX: 5, labelOffsetY: 3,
        tabletX: 43, tabletY: 84,
        tabletLabelOffsetX: 10, tabletLabelOffsetY: 0,
        mobileX: 45, mobileY: 84,
        mobileLabelOffsetX: 1.4, mobileLabelOffsetY: 4.7,
        usePercentage: true
    },
    {
        name: "3-Axis<br>String Action",
        description: "Independently adjust string height, spacing, and intonation for perfect playability.",
        x: 16, y: 58,
        labelOffsetX: -19, labelOffsetY: -3,
        tabletX: 16, tabletY: 58,
        tabletLabelOffsetX: -25, tabletLabelOffsetY: -2,
        mobileX: 18, mobileY: 58,
        mobileLabelOffsetX: -13.5, mobileLabelOffsetY: -1,
        usePercentage: true
    }
];

let tremoloHotspotManager = null;
let imageLoaded = false;

function tremoloImageLoaded() {
    imageLoaded = true;
    createTremoloContainer();
}

function createTremoloContainer() {
    const preloadImg = document.getElementById('tremolo-preload-image');
    if (!preloadImg) return;

    const imgWidth = preloadImg.naturalWidth;
    const imgHeight = preloadImg.naturalHeight;

    const imageContainer = document.getElementById('tremolo-image-container');
    if (!imageContainer) return;

    imageContainer.innerHTML = `
        <div class="interactive-container" id="tremolo-container" style="overflow:unset">
            <img src="${preloadImg.src}" alt="Tremolo Bridge Detail" class="tremolo-image" id="tremolo-image" width="${imgWidth}" height="${imgHeight}">
        </div>
        <div class="mobile-overlay"></div>
        <div class="mobile-hotspot-info">
            <div class="mobile-hotspot-close">×</div>
            <h3 class="mobile-hotspot-title"></h3>
            <p class="mobile-hotspot-description"></p>
        </div>
    `;

    setTimeout(() => {
        tremoloHotspotManager = new HotspotManager({
            containerId: 'tremolo-container',
            parts: tremoloParts,
            hasLearnMore: false,
            hasOverlay: true,
            useEmUnits: true,
            defaultCircleSize: { mobile: 50, tablet: 80, desktop: 70 }
        });

        tremoloHotspotManager.createHotspots('tremolo-container', tremoloParts);
        tremoloHotspotManager.setupMobileInteractions();
    }, 100);
}

document.addEventListener('DOMContentLoaded', function () {
    imageLoaded = false;

    const preloadImg = document.getElementById('tremolo-preload-image');
    if (preloadImg) {
        if (preloadImg.complete) {
            tremoloImageLoaded();
        } else {
            preloadImg.onload = tremoloImageLoaded;
        }
    }

    window.addEventListener('touchstart', function () {
        document.documentElement.classList.add('touch-device');
    }, { once: true });

    let resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            if (imageLoaded && tremoloHotspotManager) {
                tremoloHotspotManager.handleResize();
                tremoloHotspotManager.createHotspots('tremolo-container', tremoloParts);
                tremoloHotspotManager.setupMobileInteractions();
            }
        }, 250);
    });
});
